import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService } from "kea-resource";
import { CampoRepetidoIdentificacion, ResourceIdentificacionRepetido } from "./identificacion";

const controller = rpcController("RepGuiasDoc");

/**Resource del reporte de guias documentadas y del inventario de sucursal */
export const RepGuiasDoc = cacheResource({
    GenerarGuiasDoc: async (parametros: models.RepGuiaDocParams): Promise<string> => await controller("GenerarGuiasDoc", {}, parametros),
    GenerarInventario: async (parametros: models.RepGuiaDocParams): Promise<string> => await controller("GenerarInventario", {}, parametros),
    GenerarMercTransito: async (parametros: models.RepGuiaDocParams): Promise<string> => await controller("GenerarMercTransito", {}, parametros),
}, {
    }, {

    })


// WEBPACK FOOTER //
// ./app/resources/items/repguiasdoc.tsx